module.exports = __webpack_public_path__ + "img/img_default.64a94600.gif";